const SEARCH_BOT_REGEX =
  /Googlebot|applebot|bingbot|Google-InspectionTool|Googlebot-Image|Googlebot-News|Googlebot-Video|Googlebot-Mobile|AdsBot-Google|AdsBot-Google-Mobile|Mediapartners-Google|Feedfetcher-Google|APIs-Google|Storebot-Google|DuplexWeb-Google|Google Favicon|Google-Site-Verification|GoogleOther|Google-Extended|GoogleProducer|YandexBot|YandexImages|YandexVideo|YandexDirect|YaDirectFetcher|YandexScreenshot|YandexMetrika|YandexAccessibilityBot|YandexMobileBot|YandexSearchBot/i;

// Агрессивные AI-/скрейпер-краулеры без SEO-ценности. Именно они создают
// основную паразитную нагрузку: по данным GlitchTip Bytespider ~61%,
// Baiduspider ~5%, ClaudeBot ~3% событий 503 на getSections. Их запросы к
// тяжёлым API просто пропускаем (в отличие от search-ботов, которым нужен SEO).
const AGGRESSIVE_BOT_REGEX =
  /Bytespider|Baiduspider|ClaudeBot|GPTBot|Amazonbot|PetalBot|DataForSeoBot|SemrushBot|AhrefsBot|MJ12bot|DotBot|\bcrawler\b/i;

// Перечень краулеров и сервисов Google. По нему определяется визит со стороны
// Google: от этого зависят региональная выдача /services/ и запрет индексации
// шаблонных поддоменов в шаблоне страницы.
const GOOGLE_BOT_REGEX =
  /Googlebot|Googlebot-Mobile|Google-InspectionTool|Googlebot-Image|Googlebot-Video|Googlebot-News|AdsBot-Google|AdsBot-Google-Mobile|Mediapartners-Google|Mediapartners-Google-Mobile|Google-Read-Aloud|Feedfetcher-Google|APIs-Google|Storebot-Google|DuplexWeb-Google|Google Favicon|Google-Site-Verification/i;

export function isGoogleUserAgent(userAgent) {
  return Boolean(userAgent) && GOOGLE_BOT_REGEX.test(userAgent);
}

/**
 * Визит со стороны Google: сам робот по User-Agent, переход из выдачи по
 * referer, выставленная ранее кука `isGoogle` или явный параметр `?isGoogle`.
 * Куку ставит pages/_middleware.js — без неё признак терялся бы на переходах
 * внутри сайта.
 *
 * Источники передаются строками, а не объектом запроса: вызывается и из
 * getServerSideProps (`req.headers[...]`), и из middleware (`headers.get()`).
 *
 * @param {{ userAgent?: string, referer?: string, cookieValue?: string,
 *   queryValue?: unknown }} [source]
 */
export function isGoogleVisit(source = {}) {
  const { userAgent = "", referer = "", cookieValue = "", queryValue } = source;

  return Boolean(
    isGoogleUserAgent(userAgent) ||
      (referer || "").includes("google.com") ||
      cookieValue === "true" ||
      queryValue,
  );
}

export function isSearchRobot(userAgent) {
  const ua =
    userAgent || (typeof navigator !== "undefined" ? navigator.userAgent : "");
  if (!ua) {
    return false;
  }
  return SEARCH_BOT_REGEX.test(ua);
}

export function isAggressiveBot(userAgent) {
  const ua =
    userAgent || (typeof navigator !== "undefined" ? navigator.userAgent : "");
  if (!ua) {
    return false;
  }
  return AGGRESSIVE_BOT_REGEX.test(ua);
}

export function shouldSkipApiRequestForRobot(userAgent) {
  return isSearchRobot(userAgent) || isAggressiveBot(userAgent);
}
